import React, { useEffect, useState } from 'react';
import styles from './MainLayout.module.css';

// Import assets from Figma - using public folder paths
const heroBackground = '/assets/6b417766bd887af2d99d397fe4e9b0c97425a271.png';
const epcSparkLogo = '/assets/89f687350f1e2d34df65797c408ba2fe67965841.png';
const epcSparkSymbol = '/assets/91130d1f7b62350d93d4a04a9eca5e56eb9ebe22.png';
const downloadIcon = '/assets/70231b42847c17ad5c430d3ec452e2a0e673ab63.svg';

// Feature images from Figma
const businessDashboard = '/assets/182f63bcc54d001889bfa2c552b80d3de7724508.png';
const epcPropertyProfile = '/assets/ab49ead194fce4848736f1a8dfde7099d413908f.png';
const epcClientDetails = '/assets/11906c784d816e6ca98774df52f636545dd27625.png';
const drawingTool = '/assets/ea87feb63b0de73b2b647e9d836a084c9db44db9.png';
const epcDetails = '/assets/d1aa982f98d3199eba7ce302202f5e1d28e6ab8f.png';
const epcReport = '/assets/844d8cac6348f416f64540f6edec676f79446e7b.png';

// Benefits section images
const tabletMockup = '/assets/a77ee6191e995daf2509d058a7a792e2e7cca2c1.png';

// Icons from Figma - Updated to match exact design
const alarmClockIcon = '/assets/803a7cf4846252eeb5b318bb16ff4feb4e373d79.svg?v=3';
const documentStarburstIcon = '/assets/images/Icon.png?v=4'; // 2nd icon - document with starburst
const barChartIcon = '/assets/41a48caccea5d10ea61fa3419bd5e9eda4bdf679.svg?v=3';
const filterTickIcon = '/assets/images/quality.png?v=4'; // 4th icon - filter-tick
const gearIcon = '/assets/fbe4df8d92d4fa60e3f86f3a10844e5c32d3393c.svg?v=3'; // 5th icon - gear

// App store badges
const appStoreBadge = '/assets/2ec7d2b308fb39aaf13c80eb11d773db14184f83.svg';
const googlePlayBadge = '/assets/2aba277c2db7897be005f0e0984033d1c744d2cb.svg';

const MainLayout = () => {
  // FAQ accordion state
  const [openFaq, setOpenFaq] = useState(null);

  // Pricing toggle state
  const [isYearly, setIsYearly] = useState(false);

  // Mobile menu state
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // FAQ toggle handler
  const handleFaqToggle = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  // Pricing toggle handler
  const handlePricingToggle = () => {
    setIsYearly(!isYearly);
  };

  // Mobile menu toggle handler
  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Smooth scrolling functionality
  useEffect(() => {
    const handleSmoothScroll = (e) => {
      const target = e.target.closest('a[href^="#"]');
      if (target) {
        e.preventDefault();
        const targetId = target.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    };

    // Add event listener to the document
    document.addEventListener('click', handleSmoothScroll);

    // Cleanup
    return () => {
      document.removeEventListener('click', handleSmoothScroll);
    };
  }, []);

  // Button click handlers
  const handleLoginClick = () => {
    // Redirect to login page or open login modal
    window.location.href = '/login';
  };

  const handleDownloadClick = () => {
    // Scroll to download section or redirect to app stores
    const downloadSection = document.querySelector('.downloadSection');
    if (downloadSection) {
      downloadSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleGetStartedClick = (planType) => {
    // Handle subscription plan selection
    console.log(`Selected plan: ${planType}`);
    // You can add logic here to redirect to payment or registration
    alert(`You selected the ${planType} plan! This would redirect to payment/registration.`);
  };

  return (
    <div className={styles.mainLayout}>
      {/* Hero Section */}
      <section id="home" className={styles.heroSection}>
        <div className={styles.heroBackground}>
          <img src={heroBackground} alt="Hero Background" className={styles.heroBgImage} />
        </div>
        
            {/* Navigation */}
            <nav className={styles.navbar}>
              <div className={styles.navContainer}>
                <div className={styles.logo}>
                  <img src={epcSparkSymbol} alt="EPC Spark" className={styles.logoIcon} />
                  <div className={styles.logoText}>
                    <span className={styles.logoTextMain}>EPC</span>
                    <span className={styles.logoTextSub}>spark</span>
                  </div>
                </div>
                <div className={styles.navMenu}>
                  <a href="#home" className={styles.navLinkActive}>Home</a>
                  <a href="#features" className={styles.navLink}>Features</a>
                  <a href="#how-it-works" className={styles.navLink}>How it works</a>
                  <a href="#pricing" className={styles.navLink}>Pricing</a>
                  <a href="#support" className={styles.navLink}>Support</a>
                </div>
                <button className={styles.loginButton} onClick={handleLoginClick}>Login</button>
                <button className={styles.mobileMenuToggle} onClick={handleMobileMenuToggle}>
                  <span className={styles.hamburger}></span>
                  <span className={styles.hamburger}></span>
                  <span className={styles.hamburger}></span>
                </button>
              </div>
              
              {/* Mobile Menu */}
              <div className={`${styles.mobileMenu} ${isMobileMenuOpen ? styles.mobileMenuOpen : ''}`}>
                <div className={styles.mobileMenuContent}>
                  <a href="#home" className={styles.mobileNavLink} onClick={handleMobileMenuToggle}>Home</a>
                  <a href="#features" className={styles.mobileNavLink} onClick={handleMobileMenuToggle}>Features</a>
                  <a href="#how-it-works" className={styles.mobileNavLink} onClick={handleMobileMenuToggle}>How it works</a>
                  <a href="#pricing" className={styles.mobileNavLink} onClick={handleMobileMenuToggle}>Pricing</a>
                  <a href="#support" className={styles.mobileNavLink} onClick={handleMobileMenuToggle}>Support</a>
                  <button className={styles.mobileLoginButton} onClick={handleLoginClick}>Login</button>
                </div>
              </div>
            </nav>

        {/* Hero Content */}
        <div className={styles.heroContent}>
          <div className={styles.heroText}>
            <h1 className={styles.heroHeading}>
              <span className={styles.heroHeadingMain}>Swift. Smart.</span>
              <span className={styles.heroHeadingAccent}>Effortless.</span>
            </h1>
            <p className={styles.heroDescription}>
              Comprehensive AI-Enhanced Platform for Domestic Energy Assessors. EPC Spark optimizes every aspect with intelligent tools for floor planning, documentation, and business operations.
            </p>
            <button className={styles.downloadButton} onClick={handleDownloadClick}>
              <img src={downloadIcon} alt="Download" className={styles.downloadIcon} />
              Download
            </button>
          </div>
          <div className={styles.heroVisual}>
            <img src={epcSparkSymbol} alt="EPC Spark Symbol" className={styles.heroSymbol} />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className={styles.featuresSection}>
        <div className={styles.featuresContainer}>
          <div className={styles.featuresHeader}>
            <h2 className={styles.featuresTitle}>
              Powerful Features at Your <span className={styles.featuresTitleAccent}>Fingertips</span>
            </h2>
            <p className={styles.featuresDescription}>
              Explore the tools that make energy assessments faster, smarter, and easier. Our platform combines advanced AI with intuitive design to give EPC professionals a complete toolkit. Every feature is crafted to make your work faster, smarter, and more reliable.
            </p>
          </div>
          
          <div className={styles.featuresGrid}>
            <div className={styles.featureCard}>
              <div className={styles.featureImage}>
                <img src={businessDashboard} alt="Business Dashboard" />
              </div>
              <h3 className={styles.featureTitle}>Business Dashboard</h3>
            </div>
            
            <div className={styles.featureCard}>
              <div className={styles.featureImage}>
                <img src={epcPropertyProfile} alt="EPC Property Profile" />
              </div>
              <h3 className={styles.featureTitle}>EPC Property Profile</h3>
            </div>
            
            <div className={styles.featureCard}>
              <div className={styles.featureImage}>
                <img src={epcClientDetails} alt="EPC Client Details" />
              </div>
              <h3 className={styles.featureTitle}>EPC Client Details</h3>
            </div>
            
            <div className={styles.featureCard}>
              <div className={styles.featureImage}>
                <img src={drawingTool} alt="Drawing Tool" />
              </div>
              <h3 className={styles.featureTitle}>Drawing Tool</h3>
            </div>
            
            <div className={styles.featureCard}>
              <div className={styles.featureImage}>
                <img src={epcDetails} alt="EPC Details" />
              </div>
              <h3 className={styles.featureTitle}>EPC Details</h3>
            </div>
            
            <div className={styles.featureCard}>
              <div className={styles.featureImage}>
                <img src={epcReport} alt="EPC Report" />
              </div>
              <h3 className={styles.featureTitle}>EPC Report</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose EPC Spark Section */}
      <section id="about" className={styles.benefitsSection}>
        <div className={styles.benefitsContainer}>
          <div className={styles.benefitsContent}>
            <div className={styles.benefitsHeader}>
              <h2 className={styles.benefitsTitle}>
                Why choose <span className={styles.benefitsTitleAccent}>EPC Spark</span>
              </h2>
              <img src={epcSparkSymbol} alt="EPC Spark" className={styles.benefitsLogo} />
            </div>
            
            <div className={styles.benefitsList}>
              <div className={styles.benefitItem}>
                <div className={styles.benefitIcon}>
                  <img src={alarmClockIcon} alt="Alarm Clock" />
                </div>
                <p className={styles.benefitText}>Minimize administrative time and eliminate duplicate data entry</p>
              </div>
              
              <div className={styles.benefitItem}>
                <div className={styles.benefitIcon}>
                  <img src={documentStarburstIcon} alt="Document with Starburst" />
                </div>
                <p className={styles.benefitText}>Maintain compliance with evolving regulations</p>
              </div>
              
              <div className={styles.benefitItem}>
                <div className={styles.benefitIcon}>
                  <img src={barChartIcon} alt="Bar Chart" />
                </div>
                <p className={styles.benefitText}>Enable your clients with grant eligibility insights</p>
              </div>
              
              <div className={styles.benefitItem}>
                <div className={styles.benefitIcon}>
                  <img src={filterTickIcon} alt="Filter Tick" />
                </div>
                <p className={styles.benefitText}>Enhance the quality and precision of your EPCs</p>
              </div>
              
              <div className={styles.benefitItem}>
                <div className={styles.benefitIcon}>
                  <img src={gearIcon} alt="Gear" />
                </div>
                <p className={styles.benefitText}>Provide higher-value recommendations with confidence</p>
              </div>
            </div>
          </div>
          
          <div className={styles.benefitsVisual}>
            <img src={tabletMockup} alt="Tablet Mockup" className={styles.tabletImage} />
          </div>
        </div>
      </section>

      {/* How it Works Section */}
      <section 
        id="how-it-works"
        className={styles.howItWorksSection}
        style={{
          backgroundImage: `url('/assets/6b417766bd887af2d99d397fe4e9b0c97425a271.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className={styles.howItWorksContainer}>
          <div className={styles.howItWorksContent}>
            <h2 className={styles.howItWorksTitle}>
              How it <span className={styles.howItWorksTitleAccent}>Works</span>
            </h2>
            <p className={styles.howItWorksDescription}>
              Experience a smarter way to handle energy assessments with tools designed for accuracy and efficiency.
            </p>
            <button className={styles.howItWorksButton} onClick={handleDownloadClick}>Download</button>
          </div>
          
          <div className={styles.stepsContainer}>
            <div className={styles.step}>
              <div className={styles.stepIcon}>
                <span className={styles.stepNumber}>1</span>
              </div>
              <p className={styles.stepText}>Download Application</p>
            </div>
            
            <div className={styles.step}>
              <div className={styles.stepIcon}>
                <span className={styles.stepNumber}>2</span>
              </div>
              <p className={styles.stepText}>Register Your Account</p>
            </div>
            
            <div className={styles.step}>
              <div className={styles.stepIcon}>
                <span className={styles.stepNumber}>3</span>
              </div>
              <p className={styles.stepText}>Done, Let's continue the work</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className={styles.faqSection}>
        <div className={styles.faqContainer}>
          <div className={styles.faqHeader}>
            <h2 className={styles.faqTitle}>
              Frequently asked <span className={styles.faqTitleAccent}>Questions</span>
            </h2>
          </div>
          
          <div className={styles.faqContent}>
            <div className={styles.faqItem}>
              <div className={styles.faqQuestion} onClick={() => handleFaqToggle(0)}>
                <span className={styles.faqIcon}>{openFaq === 0 ? '▼' : '▶'}</span>
                <h3 className={styles.faqQuestionText}>How do I get started with EPC Spark?</h3>
              </div>
              {openFaq === 0 && (
                <div className={styles.faqAnswer}>
                  <p>To begin, sign up for an EPC Spark account, choose your subscription plan, and explore our easy-to-use dashboard for EPC assessments and property management.</p>
                </div>
              )}
            </div>
            
            <div className={styles.faqItem}>
              <div className={styles.faqQuestion} onClick={() => handleFaqToggle(1)}>
                <span className={styles.faqIcon}>{openFaq === 1 ? '▼' : '▶'}</span>
                <h3 className={styles.faqQuestionText}>What types of EPC assessments can I perform?</h3>
              </div>
              {openFaq === 1 && (
                <div className={styles.faqAnswer}>
                  <p>EPC Spark supports all standard domestic energy assessments including SAP calculations, RdSAP assessments, and compliance reporting for residential properties.</p>
                </div>
              )}
            </div>
            
            <div className={styles.faqItem}>
              <div className={styles.faqQuestion} onClick={() => handleFaqToggle(2)}>
                <span className={styles.faqIcon}>{openFaq === 2 ? '▼' : '▶'}</span>
                <h3 className={styles.faqQuestionText}>Is there a limit on assessments for free accounts?</h3>
              </div>
              {openFaq === 2 && (
                <div className={styles.faqAnswer}>
                  <p>Free accounts include 5 assessments per month. Upgrade to our Standard, Professional, or Premium plans for higher limits and additional features.</p>
                </div>
              )}
            </div>
            
            <div className={styles.faqItem}>
              <div className={styles.faqQuestion} onClick={() => handleFaqToggle(3)}>
                <span className={styles.faqIcon}>{openFaq === 3 ? '▼' : '▶'}</span>
                <h3 className={styles.faqQuestionText}>Can EPC Spark integrate with my existing tools?</h3>
              </div>
              {openFaq === 3 && (
                <div className={styles.faqAnswer}>
                  <p>Yes, EPC Spark offers API integrations and export capabilities to work seamlessly with your existing property management and CRM systems.</p>
                </div>
              )}
            </div>
            
            <div className={styles.faqItem}>
              <div className={styles.faqQuestion} onClick={() => handleFaqToggle(4)}>
                <span className={styles.faqIcon}>{openFaq === 4 ? '▼' : '▶'}</span>
                <h3 className={styles.faqQuestionText}>How does EPC Spark ensure the security of my data?</h3>
              </div>
              {openFaq === 4 && (
                <div className={styles.faqAnswer}>
                  <p>We use enterprise-grade encryption, secure cloud storage, and comply with GDPR regulations to protect your data and client information.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className={styles.pricingSection}>
        <div className={styles.pricingContainer}>
          <div className={styles.pricingHeader}>
            <h2 className={styles.pricingTitle}>
              Unlock Your EPC <span className={styles.pricingTitleAccent}>Toolkit</span>
            </h2>
            <p className={styles.pricingDescription}>
              Flexible subscription plans designed to scale with your business.
            </p>
          </div>
          
          <div className={styles.pricingToggle}>
            <button 
              className={isYearly ? styles.toggleButton : styles.toggleButtonActive}
              onClick={handlePricingToggle}
            >
              Monthly
            </button>
            <div className={styles.yearlyToggleContainer}>
              <button 
                className={isYearly ? styles.toggleButtonActive : styles.toggleButton}
                onClick={handlePricingToggle}
              >
                Yearly
              </button>
              <span className={styles.saveBadge}>Save 10%</span>
            </div>
          </div>
          
          <div className={styles.pricingCards}>
            <div className={styles.pricingCard}>
              <div className={styles.cardHeader}>
                <h3 className={styles.cardTitle}>Standard</h3>
                <div className={styles.cardPrice}>
                  <span className={styles.currency}>$</span>
                  <span className={styles.amount}>{isYearly ? '13.50' : '15'}</span>
                  <span className={styles.period}>/mo</span>
                </div>
                <p className={styles.cardSubtitle}>Freelancers / Part-Time</p>
              </div>
              
              <div className={styles.cardFeatures}>
                <h4 className={styles.featuresTitle}>What's included:</h4>
                <ul className={styles.featuresList}>
                  <li className={styles.featureItemHighlight}>30 Assessments per month</li>
                  <li className={styles.featureItem}>Complete EPC Spark Tool Suite</li>
                  <li className={styles.featureItem}>Professional Client & Property Management</li>
                  <li className={styles.featureItem}>AI-Powered EPC Assistant</li>
                  <li className={styles.featureItem}>Advanced Heat Loss Analytics</li>
                  <li className={styles.featureItem}>Smart Voice-to-Text Technology</li>
                </ul>
              </div>
              
              <button className={styles.cardButton} onClick={() => handleGetStartedClick('Standard')}>Get Started</button>
            </div>
            
            <div className={styles.pricingCardFeatured}>
              <div className={styles.cardHeader}>
                <h3 className={styles.cardTitle}>Professional</h3>
                <div className={styles.cardPrice}>
                  <span className={styles.currency}>$</span>
                  <span className={styles.amount}>{isYearly ? '22.50' : '25'}</span>
                  <span className={styles.period}>/mo</span>
                </div>
                <p className={styles.cardSubtitle}>Full-Time Assessors</p>
              </div>
              
              <div className={styles.cardFeatures}>
                <h4 className={styles.featuresTitle}>What's included:</h4>
                <ul className={styles.featuresList}>
                  <li className={styles.featureItemHighlight}>60 Assessments per month</li>
                  <li className={styles.featureItem}>Complete EPC Spark Tool Suite</li>
                  <li className={styles.featureItem}>Professional Client & Property Management</li>
                  <li className={styles.featureItem}>AI-Powered EPC Assistant</li>
                  <li className={styles.featureItem}>Advanced Heat Loss Analytics</li>
                  <li className={styles.featureItem}>Smart Voice-to-Text Technology</li>
                </ul>
              </div>
              
              <button className={styles.cardButtonFeatured} onClick={() => handleGetStartedClick('Professional')}>Get Started</button>
            </div>
            
            <div className={styles.pricingCard}>
              <div className={styles.cardHeader}>
                <h3 className={styles.cardTitle}>Premium</h3>
                <div className={styles.cardPrice}>
                  <span className={styles.currency}>$</span>
                  <span className={styles.amount}>{isYearly ? '31.50' : '35'}</span>
                  <span className={styles.period}>/mo</span>
                </div>
                <p className={styles.cardSubtitle}>High-Volume Professionals</p>
              </div>
              
              <div className={styles.cardFeatures}>
                <h4 className={styles.featuresTitle}>What's included:</h4>
                <ul className={styles.featuresList}>
                  <li className={styles.featureItemHighlight}>90 Assessments per month</li>
                  <li className={styles.featureItem}>Complete EPC Spark Tool Suite</li>
                  <li className={styles.featureItem}>Professional Client & Property Management</li>
                  <li className={styles.featureItem}>AI-Powered EPC Assistant</li>
                  <li className={styles.featureItem}>Advanced Heat Loss Analytics</li>
                  <li className={styles.featureItem}>Smart Voice-to-Text Technology</li>
                </ul>
              </div>
              
              <button className={styles.cardButton} onClick={() => handleGetStartedClick('Premium')}>Get Started</button>
            </div>
          </div>
        </div>
      </section>

      {/* Download Section */}
      <section className={styles.downloadSection}>
        <div 
          className={styles.downloadBackgroundLogo}
          style={{
            backgroundImage: `url('/assets/91130d1f7b62350d93d4a04a9eca5e56eb9ebe22.png')`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
          }}
        ></div>
        <div className={styles.downloadContainer}>
          <div className={styles.downloadContent}>
            <h2 className={styles.downloadTitle}>
              Download EPC Spark <span className={styles.downloadTitleAccent}>App</span>
            </h2>
            <p className={styles.downloadDescription}>
              Take your energy assessments anywhere with EPC Spark. Manage projects, generate reports, and capture site data all from your device.
            </p>
            
                <div className={styles.appStoreBadges}>
                  <img src={appStoreBadge} alt="Download on the App Store" className={styles.appStoreBadge} />
                  <img src={googlePlayBadge} alt="Get it on Google Play" className={styles.appStoreBadge} />
                </div>
            
            <div className={styles.downloadFeatures}>
              <div className={styles.downloadFeature}>
                <div className={styles.featureIcon}>⚡</div>
                <span className={styles.featureText}>EPC Ready</span>
              </div>
              <div className={styles.downloadFeature}>
                <div className={styles.featureIcon}>🔒</div>
                <span className={styles.featureText}>Secure & Private</span>
              </div>
              <div className={styles.downloadFeature}>
                <div className={styles.featureIcon}>📱</div>
                <span className={styles.featureText}>Cross Platform</span>
              </div>
            </div>
          </div>
          
          <div className={styles.downloadVisual}>
            <img src={tabletMockup} alt="Tablet with EPC Spark App" className={styles.downloadImage} />
          </div>
        </div>
        
        {/* Statistics Section - Part of Download Section */}
        <div className={styles.statsSection}>
          <div className={styles.statsContainer}>
            <div className={styles.statItem}>
              <h3 className={styles.statLabel}>Downloads</h3>
              <p className={styles.statValue}>10K+</p>
            </div>
            <div className={styles.statDivider}></div>
            <div className={styles.statItem}>
              <h3 className={styles.statLabel}>Ratings</h3>
              <p className={styles.statValue}>4.8 ⭐</p>
            </div>
            <div className={styles.statDivider}></div>
            <div className={styles.statItem}>
              <h3 className={styles.statLabel}>Support</h3>
              <p className={styles.statValue}>24/7</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <footer id="support" className={styles.footerSection}>
        <div className={styles.footerContainer}>
          <div className={styles.footerContent}>
            <div className={styles.footerBrand}>
              <div className={styles.footerLogoContainer}>
                <img src={epcSparkSymbol} alt="EPC Spark" className={styles.footerLogo} />
                <h3 className={styles.footerBrandName}>EPC Spark</h3>
              </div>
              <p className={styles.footerTagline}>Spark your EPC workflow</p>
            </div>
            
            <div className={styles.footerLinks}>
              <div className={styles.footerColumn}>
                <h4 className={styles.footerColumnTitle}>USE LINK</h4>
                <div className={styles.footerLinkColumn}>
                  <a href="#features" className={styles.footerLink}>Feature</a>
                  <a href="/about" className={styles.footerLink}>About us</a>
                  <a href="#testimonials" className={styles.footerLink}>Testimonials</a>
                  <a href="#pricing" className={styles.footerLink}>Pricing</a>
                  <a href="/contact" className={styles.footerLink}>Contact</a>
                </div>
              </div>
              
              <div className={styles.footerColumn}>
                <h4 className={styles.footerColumnTitle}>SUPPORT</h4>
                <div className={styles.footerLinkColumn}>
                  <a href="/contact" className={styles.footerLink}>Contact us</a>
                  <a href="#help" className={styles.footerLink}>Help</a>
                </div>
              </div>
              
              <div className={styles.footerColumn}>
                <h4 className={styles.footerColumnTitle}>LOCATION</h4>
                <p className={styles.footerAddress}>
                  128 City Road, London,<br />
                  EC1V 2NX<br />
                  United Kingdom
                </p>
              </div>
              
              <div className={styles.footerColumn}>
                <h4 className={styles.footerColumnTitle}>SOCIAL</h4>
                <div className={styles.socialLinks}>
                  <a href="https://x.com/EpcSpark" className={styles.socialLink} aria-label="X (Twitter)">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18.3 4.5h2.1l-6.1 7 7 8.9h-5.5l-4.2-5.4-4.8 5.4H4.7l6.5-7.2L4.7 4.5h5.6l3.9 5.1 4.1-5.1Z"/>
                    </svg>
                  </a>
                  <a href="https://www.instagram.com/epc.sparkofficial/" className={styles.socialLink} aria-label="Instagram">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7Zm5 3.5A5.5 5.5 0 1 1 6.5 13 5.5 5.5 0 0 1 12 7.5Zm0 2A3.5 3.5 0 1 0 15.5 13 3.5 3.5 0 0 0 12 9.5Zm5.75-3.25a1 1 0 1 1-1 1 1 1 0 0 1 1-1Z"/>
                    </svg>
                  </a>
                  <a href="https://www.linkedin.com/company/epc-spark/about/?viewAsMember=true" className={styles.socialLink} aria-label="LinkedIn">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4.98 3.5a2.5 2.5 0 1 0 .02 5 2.5 2.5 0 0 0-.02-5ZM3 8.98h4v12H3v-12Zm7 0h3.83v1.64h.05c.53-1 1.82-2.06 3.75-2.06 4.01 0 4.75 2.64 4.75 6.07v6.35h-4v-5.64c0-1.35-.03-3.1-1.89-3.1-1.9 0-2.19 1.48-2.19 3v5.74h-4v-12Z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          
          <div className={styles.footerDivider}></div>
          
          <div className={styles.footerBottom}>
            <p className={styles.copyright}>© EPC Spark 2025 All Rights Reserved.</p>
            <div className={styles.legalLinks}>
              <a href="/privacypolicy" className={styles.legalLink}>Privacy Policy</a>
              <a href="/footer-terms-and-conditions" className={styles.legalLink}>Terms & Conditions</a>
              <a href="#" className={styles.legalLink}>Cookie Policy</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MainLayout; 